import { render, staticRenderFns } from "./EvaluateList.vue?vue&type=template&id=33370719&scoped=true&"
import script from "./EvaluateList.vue?vue&type=script&lang=js&"
export * from "./EvaluateList.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateList.vue?vue&type=style&index=0&id=33370719&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33370719",
  null
  
)

export default component.exports